


class CustomEvents {

    static OPEN_LOGIN_PANEL = 'OPEN_LOGIN_PANEL';
    static OPEN_VIP_PANEL = 'OPEN_VIP_PANEL';
    static OPEN_MY_ORDER_PANEL = 'OPEN_MY_ORDER_PANEL';
    static DIR_HANDLE_CHANGE = 'DIR_HANDLE_CHANGE';
}

export default CustomEvents;